<button
    #pickerOrigin="cdkOverlayOrigin"
    cdkOverlayOrigin
    class="shrink-0"
    interacta-icon-button
    type="button"
    [disabled]="disabled()"
    [icon]="'plus'"
    [label]="'AI.ADD_ATTACHMENT' | translate"
    [size]="'regular'"
    (click)="open()"
></button>
<interacta-menu-dialog
    [open]="isOpen()"
    [origin]="pickerOrigin"
    [positionX]="'after'"
    (closing)="close()"
>
    <div
        class="w-380 gap-y-16"
        interactaMenuDecorator
        style="max-height: min(42rem, 80vh); min-height: min(32rem, 80vh)"
    >
        <section class="px-16 pt-16">
            <section class="flex items-center gap-x-8">
                <interacta-image
                    alt=""
                    [classes]="'size-24'"
                    [src]="
                        themeMode() === 'dark'
                            ? './assets/shared/images/ai/ai-interacta-logo_dark.svg'
                            : './assets/shared/images/ai/ai-interacta-logo_light.svg'
                    "
                />
                <h2 class="typo-t6">{{ 'AI.ADD_ATTACHMENT' | translate }}</h2>
                <button
                    class="ml-auto"
                    interacta-icon-button
                    type="button"
                    [icon]="'close'"
                    [label]="'UI.BUTTON.CLOSE' | translate"
                    [size]="'small'"
                    (click)="close()"
                ></button>
            </section>
            <p class="mt-8 typo-xs">
                {{ 'AI.ADD_ATTACHMENT_DESCRIPTION' | translate }}
            </p>
        </section>
        <interacta-separator [thickness]="'soft'" />
        <section class="flex grow flex-col gap-y-12 overflow-y-auto px-16">
            @if (isInitialLoading()) {
                <interacta-loader class="m-auto" [size]="'large'" />
            } @else if (hasAttachments()) {
                @for (section of sections; track section.entityType) {
                    @let sectionList = listOf(section.entityType);
                    @if (sectionList && sectionList.totalCount) {
                        <interacta-attachments-selection-list
                            [attachments]="sectionList"
                            [disableScanPending]="true"
                            [selectedAttachment]="selected()?.id ?? null"
                            [title]="section.titleKey | translate"
                            (loadMore)="loadMore(section.entityType)"
                            (selectAttachment)="toggleSelection($event)"
                        />
                    }
                }
            } @else {
                <p class="self-center">
                    {{ 'AI.NO_AVAILABLE_ATTACHMENTS' | translate }}
                </p>
                <interacta-image
                    class="self-center"
                    [alt]="'AI.NO_AVAILABLE_ATTACHMENTS' | translate"
                    [classes]="'object-contain shrink-0 h-308'"
                    [src]="'assets/shared/images/doodles/empty-page.png'"
                />
            }
        </section>
        <section class="flex justify-end gap-x-16 px-16 pb-16">
            <button
                interacta-button
                type="button"
                [label]="'AI.CANCEL' | translate"
                (click)="close()"
            ></button>
            <button
                interacta-button
                type="button"
                [disabled]="!selected()"
                [label]="'AI.INSERT' | translate"
                [style]="'filled'"
                (click)="confirm()"
            ></button>
        </section>
    </div>
</interacta-menu-dialog>
